import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SS4_FILE_EXTENSIONS, SS4_FILE_MIMES } from '@constants/company-documents';
import { enumFileExtension } from '@enum/enumFileExtension';

// #13356 — SS-4 (IRS EIN assignment letter) upload block, rendered inside Business info under the
// Employer Identification Number input. Unlike the logo/photo-id cards it accepts PDF as well as images.
@Component({
  selector: 'company-ss4-form',
  templateUrl: './company-ss4-form.component.html',
  styleUrls: ['./company-ss4-form.component.scss'],
})
export class CompanySs4FormComponent {
  @Input() public ss4Uri: string;
  @Input() public companyId: number;
  @Input() public isLoading: boolean = false;
  @Input() public isNonImageDocument: boolean = false;
  @Input() public fileName: string = '';
  /** #13356 — false once the POA is already signed/paid: the document becomes recommended, not required. */
  @Input() public isRequired: boolean = true;

  @Output() public uploadSs4Source$: EventEmitter<File> = new EventEmitter<File>();

  public acceptMimes: string = SS4_FILE_MIMES.join(',');
  public allowedExtensions: enumFileExtension[] = SS4_FILE_EXTENSIONS;

  public get badgeLabel(): string {
    return this.isRequired ? 'LABELS.REQUIRED' : 'LABELS.OPTIONAL';
  }

  public get badgeClass(): string {
    return this.isRequired ? 'required-badge' : '';
  }

  public uploadSs4(file: File): void {
    this.uploadSs4Source$.emit(file);
  }
}
